import React from "react";
import { withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import UserInput from "../../components/UserInput/UserInput";
import axios from "../../utils/Axios/axiosProxy";
import styles from "./UserEntry.module.scss";
import userInputStyle from "../../components/UserInput/UserInput.module.scss";
import i18n from "../../utils/LanguageSelector/i18n";
import { useEffect } from "react";

function ForgotPassword() {
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  let startingMsg = i18n.t("forgotpw.content1");
  useEffect(() => {
    setMessage(i18n.t(startingMsg));
  }, [startingMsg]);

  const sendResetLink = () => {
    let data = { email: email };
    axios
      .post("/api/user/recover", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response.data.message);
        if (response.data.message === "recovery email sent") {
          setMessage(`${i18n.t("forgotpw.content2")} ${email}`);
        }
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data.message);
        if (error.response.data === "email not in db") {
          setMessage(`${i18n.t("forgotpw.content3")} ${email}`);
        }
      })
      .catch((error) => console.log("submitToDB error", error));
  };
  return (
    <div className={styles.UserEntryContainer}>
      <div className={styles.UserEntryContent}>
        <h2 className={styles.UserEntryTitle}>
          {" "}
          {i18n.t("forgotpw.question")}
        </h2>
        <div className={`${styles.UserEntryInputs} FlexCenter Column`}>
          <UserInput
            key="email"
            name={i18n.t("general.email")}
            id="email"
            className={userInputStyle.RegInput}
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
          />
          <div className={styles.UserEntryErrorMessageContainer}>
            <span className="OrangeFont Bold">{message}</span>
          </div>
          <div className={styles.UserEntryButton}>
            <Button
              onClick={() => {
                if (email.length > 4) {
                  sendResetLink();
                }
              }}
              className="ToreaBay Medium MarginHorizontal"
            >
              {i18n.t("general.send")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(ForgotPassword);
